/**
 * goToChannelList action.
 */
import Pages from '@pages';
import { store } from '../../store/store';
import { pushRoute } from '../../store/thunks/route.thunk';

/**
 * Function to redirect to the channel list page.
 */
export default function goToChannelList() {
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CHANNEL_LIST },
      params: { current: { stacked: true }, push: true },
    })
  );
}
